import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.compose';
import { translate } from 'react-i18next';

function DrivenPlateDetails({ product: { parameter, meta, code }, t }) {
  const pd = code.startsWith('9');
  return (
    <div className="table-wrapper">
      <div className="div-table details-table">
        <div className="div-table-body">
          {parameter && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.parameter')}</div>
              <div className="div-table-cell">{parameter}</div>
            </div>
          )}
          {meta.tipo && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.type')}</div>
              <div className="div-table-cell">{meta.tipo}</div>
            </div>
          )}
          {meta.facing_size && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.facing_size')}</div>
              <div className="div-table-cell">{meta.facing_size}</div>
            </div>
          )}
          {meta.splines && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.splines')}</div>
              <div className="div-table-cell">{meta.splines}</div>
            </div>
          )}
          {meta.z && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.z')}</div>
              <div className="div-table-cell">{meta.z}</div>
            </div>
          )}
          <div className="div-table-row">
            <div className="div-table-cell">{t('driven_plate_details.pd')}</div>
            <div className="div-table-cell">{pd ? t('common:yes') : t('common:not')}</div>
          </div>
          {meta.cxfacing && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.cxfacing')}</div>
              <div className="div-table-cell">{meta.cxfacing}</div>
            </div>
          )}
          {meta.piastrine && meta.piastrine !== '0' && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.piastrine')}</div>
              <div className="div-table-cell">{meta.piastrine}</div>
            </div>
          )}
          {meta.mounted_with && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.mounted_with')}</div>
              <div className="div-table-cell">{meta.mounted_with}</div>
            </div>
          )}
          {meta.inc && (
            <div className="div-table-row">
              <div className="div-table-cell">{t('driven_plate_details.inc')}</div>
              <div className="div-table-cell">{meta.inc}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

DrivenPlateDetails.defaultProps = {};
DrivenPlateDetails.propTypes = {
  product: PropTypes.shape({
    meta: PropTypes.shape({
      tipo: PropTypes.string,
      facing_size: PropTypes.string,
      splines: PropTypes.string,
      z: PropTypes.string,
      pd: PropTypes.string,
      cxfacing: PropTypes.string,
      piatrine: PropTypes.string,
      inc: PropTypes.string,
      mounted_with: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
export default compose(
  translate('product'),
)(DrivenPlateDetails);
